import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CreditCard, Smartphone, Building2, Bitcoin, Wallet, Lock } from 'lucide-react';
const methods = [{
  name: 'VISA',
  icon: <CreditCard className="w-5 h-5" data-id="element-284" />
}, {
  name: 'Mastercard',
  icon: <CreditCard className="w-5 h-5" data-id="element-285" />
}, {
  name: 'PayPal',
  icon: <Wallet className="w-5 h-5" data-id="element-286" />
}, {
  name: 'Pago Móvil',
  icon: <Smartphone className="w-5 h-5" data-id="element-287" />
}, {
  name: 'Binance',
  icon: <Bitcoin className="w-5 h-5" data-id="element-288" />
}, {
  name: 'Transferencia Bancaria',
  icon: <Building2 className="w-5 h-5" data-id="element-289" />
}, {
  name: 'Zelle',
  icon: <Wallet className="w-5 h-5" data-id="element-290" />
}];
export function PaymentMethods() {
  return <section className="py-14 bg-white border-t border-cream-dark" aria-label="Formas de pago aceptadas" data-id="element-291">
      <div className="max-w-5xl mx-auto px-6" data-id="element-292">
        <FadeIn data-id="element-293">
          <div className="text-center mb-8" data-id="element-294">
            <div className="inline-flex items-center gap-2 text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-accent mb-3" data-id="element-295">
              <Lock className="w-4 h-4" data-id="element-296" />
              Pago 100% seguro
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-brown-dark mb-2" data-id="element-297">
              Formas de pago aceptadas
            </h2>
            <p className="text-brown/70 font-serif" data-id="element-298">
              Elige la opción que más te convenga al momento de comprar.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-299">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-300">
            {methods.map(method => <div key={method.name} className="flex items-center gap-2 bg-cream/50 border border-cream-dark rounded-xl px-4 py-3 hover:border-accent/50 hover:bg-cream transition-colors" data-id="element-301">
                <span className="text-accent flex-shrink-0" data-id="element-302">{method.icon}</span>
                <span className="text-brown-dark font-bold text-sm md:text-base whitespace-nowrap" data-id="element-303">
                  {method.name}
                </span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}